export interface GradeConfig {
  key: string;
  label: string;
}

export type PolymerGroup = 'PE' | 'PP' | 'PS' | 'PVC' | 'PET' | 'PC';

export const POLYMER_GRADES: Record<PolymerGroup, GradeConfig[]> = {
  PE: [
    { key: 'HDPEBlowMLDG', label: 'HDPE Blow MLDG' },
    { key: 'HDPEHMWFilm', label: 'HDPE HMW Film' },
    { key: 'HDPEINJ', label: 'HDPE INJ' },
    { key: 'LDPEGPFilm', label: 'LDPE GP Film' },
    { key: 'LLDPEButene', label: 'LLDPE Butene' },
    { key: 'LLDPEHexene', label: 'LLDPE Hexene' },
  ],
  PP: [
    { key: 'PPHomo', label: 'Homopolymer' },
    { key: 'PPCopolymerImpact', label: 'PP Copolymer Impact' },
    { key: 'PPCopolymerRandom', label: 'PP Copolymer Random' },
  ],
  PS: [
    { key: 'HIPS', label: 'HIPS' },
    { key: 'GPPS', label: 'GPPS' },
  ],
  PVC: [
    { key: 'PVC', label: 'PVC' },
  ],
  PET: [
    { key: 'PETFormula', label: 'PET' },
  ],
  PC: [
    { key: 'PCFormula', label: 'PC' },
  ],
};
